import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {HttpErrorResponse} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {FuseConfirmationService} from '../../../@fuse/services/confirmation';
import { DossierIntervention } from 'app/models/dossier_intervention.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DossierInterventionService } from 'app/services/dossier_intervention.service';
import { UserService } from 'app/services/user.service';
import { UserService as CoreUserService } from 'app/core/user/user.service';
import { User } from 'app/models/user.model';
import { User as CoreUser } from 'app/core/user/user.types';
import {debounce} from "lodash-es";

@Component({
  selector: 'app-dossier-intervention',
  templateUrl: './dossier-intervention.component.html',
  styleUrls: ['./dossier-intervention.component.scss']
})
export class DossierInterventionComponent implements OnInit {

    dossiersInterventions: DossierIntervention[] = [];
    isLoaded: boolean = false;
    currentDossierIntervention: DossierIntervention = new DossierIntervention();
    errors: string[] = [];
    ajout: boolean = false;
    success: boolean = false;
    error: boolean = false;
    noDossierDejaUtiliser: boolean = false;
    users: User[] = [];
    tabIndex: number = 0;
    user: CoreUser;
    unsavedChanges: boolean = false;

    searchValue: string = '';

    dossierInterventionForm: FormGroup;

    private routeSub: Subscription;

    constructor(
        private dossierInterventionService: DossierInterventionService,
        private userService: UserService,
        private _userService: CoreUserService,
        private confirmationService: FuseConfirmationService
    ) {}

    ngOnInit(): void {
        this._userService.user$
            .subscribe((user: CoreUser) => {
                this.user = user;
            });

        this.getDossierInterventions();
        this.getUsers();
        const usersId = [];
        if(this.currentDossierIntervention.users != undefined && this.currentDossierIntervention.users.length > 0){
            for(const user of this.currentDossierIntervention.users){
                usersId.push(user.id);
            }
        }
        this.dossierInterventionForm = new FormGroup({
            no_dossier: new FormControl(this.currentDossierIntervention.no_dossier, [Validators.required]),
            compagnie_assurance: new FormControl(this.currentDossierIntervention.compagnie_assurance),
            nom_assure: new FormControl(this.currentDossierIntervention.nom_assure),
            date_perte: new FormControl(this.currentDossierIntervention.date_perte),
            adresse_propriete_endommagee: new FormControl(this.currentDossierIntervention.adresse_propriete_endommagee),
            personne_contact: new FormControl(this.currentDossierIntervention.personne_contact),
            commentaires: new FormControl(this.currentDossierIntervention.commentaires),
            date_rendez_vous: new FormControl(this.currentDossierIntervention.date_rendez_vous),
            users_id: new FormControl(usersId),
        });

        this.dossierInterventionForm.valueChanges.subscribe(() => {
            this.unsavedChanges = this.dossierInterventionForm.dirty; // Mark as true if any form field is dirty
        });
    }

    getDossierInterventions(): void {
        this.dossierInterventionService.getDossiersInterventionsForUser(this.user.id).subscribe((dossierIntervention) => {
            this.dossiersInterventions = dossierIntervention;
            this.isLoaded = true;
        });
    }

    getUsers(): void {
        this.userService.getUsers().subscribe((users) => {
            this.users = users;
        });
    }

    get f()
    {
        return this.dossierInterventionForm?.controls;
    }

    onFormSubmit(): void{
        this.error = false;
        this.noDossierDejaUtiliser = false;
        this.success = false;
        this.dossierInterventionForm.markAllAsTouched();
        this.ajout = false;
        this.getDossierInterventions();
    }

    add(){
        this.ajout = true;
        if(this.currentDossierIntervention.id != 0){
            this.tabIndex = 0;
            const dossierIntervention = new DossierIntervention();
            dossierIntervention.id = 0;
            this.dossiersInterventions.unshift(dossierIntervention);
            this.currentDossierIntervention = dossierIntervention;
            this.dossierInterventionForm.reset();
        }
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }

    hasUnsavedChanges(): Observable<boolean> {
        if (this.unsavedChanges) {
            return new Observable<boolean>(observer => {
            this.confirmationService.open().afterClosed().subscribe(result => {
                if (result === 'confirmed') {
                observer.next(true);  // Allow navigation
                } else {
                observer.next(false);  // Prevent navigation
                }
                observer.complete();
            });
            });
        }
    }

    closeAjout(): void {
        this.ajout = false;
        this.getDossierInterventions();
    }

    search(event): void {
        const inputValue = event.target.value;
        this.searchValue = inputValue;
        this.isLoaded = false;
        this.dossierInterventionService.getDossiersInterventionsForUser(this.user.id, this.searchValue).subscribe((dossierIntervention) => {
            if (this.searchValue === inputValue) {
                this.dossiersInterventions = dossierIntervention;
                this.isLoaded = true;
            }
        });
    }
}
